<form [formGroup]="creditInfoForm">
  <div class="row form-group">
    <div class="col-lg-4 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'equifaxScore' | qaSlug">
      <label class="control-label">EFX </label>
      <div class="median-column">
        <input class="txt-box form-control w-100 border-right-0 border-radius-r-0" pInputText formControlName="equifaxScore" id="equifaxScore" />
        @if (borrower?.creditScores.creditScoreMedian && borrower?.creditScores.equifaxScore === borrower?.creditScores?.creditScoreMedian) {
          <span class="p-button btn-median" tabindex="-1"> Median </span>
        }
      </div>
    </div>
    <div class="col-lg-4 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'transUnionScore' | qaSlug">
      <label class="control-label">TRU</label>
      <div class="median-column">
        <input
          class="txt-box form-control w-100 border-right-0 border-radius-r-0"
          pInputText
          formControlName="transUnionScore"
          id="transUnionScore"
        />
        @if (borrower?.creditScores.transUnionScore && borrower?.creditScores.transUnionScore === borrower?.creditScores?.creditScoreMedian) {
          <span class="p-button btn-median" tabindex="-1"> Median </span>
        }
      </div>
    </div>
    <div class="col-lg-4 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'experianScore' | qaSlug">
      <label class="control-label">XPN</label>
      <div class="median-column">
        <input class="txt-box form-control w-100 border-right-0 border-radius-r-0" pInputText formControlName="experianScore" id="experianScore" />
        @if (borrower?.creditScores.experianScore && borrower?.creditScores.experianScore === borrower?.creditScores?.creditScoreMedian) {
          <span class="p-button btn-median" tabindex="-1"> Median </span>
        }
      </div>
    </div>
    <div class="col-lg-4 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'mobileEConsent' | qaSlug">
      <label class="control-label" for="{{ uniqueId + '-mobileEConsent' }}">Mobile E Consent</label>
      <p-datepicker
        styleClass="w-100"
        formControlName="mobileEConsent"
        [readonlyInput]="true"
        placeholder="MM/DD/YYYY"
        cmg-date-mask
        appendTo="body"
        id="{{ uniqueId + '-mobileEConsent' }}"
      />
    </div>
    <div class="col-lg-4 col-xs-6 form-group d-flex flex-column" [attr.automation-id]="autoIdPrefix() + 'mobileCreditAuthorization' | qaSlug">
      <label class="control-label" for="{{ uniqueId + '-mobileCreditAuthorization' }}">Mobile Credit Authorization</label>
      <p-datepicker
        styleClass="w-100"
        formControlName="mobileCreditAuthorization"
        placeholder="MM/DD/YYYY"
        cmg-date-mask
        appendTo="body"
        id="{{ uniqueId + '-mobileCreditAuthorization' }}"
      />
    </div>
  </div>
</form>
